import {observer} from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import {useEffect} from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import ChargedFeesInvoiceEditor from "./charged-fees-invoice-editor";
import {CHARGED_FEES_INVOICE_SCOPE} from "./constants";
import emailContentListStore from "../../../../stores/email-content-list-store";

const ChargedFeesInvoiceEditorPage: React.FC = observer(() => {
    const {setSubTitles} = usePage();

    useEffect(() => {
        setSubTitles(['Content', 'Charged Fees Draft Order']);
        emailContentListStore.onShowTranslationButton(false);
    }, [setSubTitles]);

    const {selectedLocale} = useTranslation();

    return (
        <TranslationScope scope={CHARGED_FEES_INVOICE_SCOPE} locale={selectedLocale}>
            <ChargedFeesInvoiceEditor/>
        </TranslationScope>
    );
});

export default ChargedFeesInvoiceEditorPage;